import React, { useState, useEffect } from 'react';
import StaticModal from 'shared/common/modal/staticModal';
import { Link, useHistory } from 'react-router-dom';
import { userStore } from 'store/UserStore';

// import './Redeem.css';
interface PropsType {
  redirectFunc?: any;
  showModal?: any;
  closeModal?: any;
  proceed?: any;
  cancel?: any;
  text?: any;
  keytext?: any;
  okButton?: any;
  cancelButton?: any;
  title?: any;
}

const RedeemGiftModal: React.FC<PropsType> = ({
  redirectFunc,
  showModal,
  closeModal,
  proceed,
  cancel,
  text,
  keytext,
  okButton,
  cancelButton,
  title,
}) => {
  //   const [showModal, setShowModal] = useState(false);
  const [customer] = userStore((state: any) => [state.customer]);
  const history = useHistory();
  //   const redirectFunc = () => {
  //     history.push('/profile?nomination=true');
  //   };
  //   useEffect(() => {
  //     // Check if the popup has been shown before in local storage
  //     if (
  //       customer?.isFirstBuy &&
  //       customer?.nomineeDetails?.length < 1 &&
  //       customer.customerCategory === 'UNREGISTERED'
  //     ) {
  //       const hasPopupBeenShown = localStorage.getItem('popupShown');
  //       if (!hasPopupBeenShown) {
  //         setShowModal(true);
  //       }
  //     }
  //     // else if (customer?.nomineeDetails?.length > 0) {
  //     //   setShowModal(false);
  //     // }
  //   }, []);

  const closePopup = () => {
    // Mark the popup as shown in local storage
    // localStorage.setItem('popupShown', 'true');
    closeModal(false);
  };
  return (
    <div>
      {customer.customerCategory === 'UNREGISTERED' && (
        <StaticModal
          show={showModal}
          handleClose={() => cancel()}
          title={title}
          onClose={() => {
            cancel();
          }}
          // size='lg'

          center
        >
          <div>
            <div className='RedeemMainDiv p-3 '>
              <p className='text-1 text-center'>
                {keytext == 'gift' ? (
                  <p>
                    Congratulations! You have received a gift🎁
                    <br />
                    To check out your gift, please{' '}
                    <Link
                      to='/gift?giftListReceived=true'
                      style={{
                        color: '#2575fc',
                        textDecoration: 'underline',
                      }}
                    >
                      visit
                    </Link>{' '}
                    the Gift page.
                    {/* You have received a gift🎁 <br />
                      To claim it, please go to Gift Page. Thank you! */}
                  </p>
                ) : (
                  text
                )}
                <i className='fa-solid fa-hand-back-point-right'></i>
              </p>
              {/* <br /> */}
              {keytext == 'gift' ? (
                ''
              ) : (
                <div className='d-flex justify-content-center'>
                  <button
                    className='btn btn-primary m-2'
                    onClick={() => proceed()}
                  >
                    {okButton}
                  </button>
                  <button
                    className='btn btn-secondary m-2'
                    onClick={() => cancel()}
                  >
                    {cancelButton}
                  </button>
                </div>
              )}
            </div>
          </div>
        </StaticModal>
      )}
    </div>
  );
};

export default RedeemGiftModal;
